<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "BusinessForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        agency_id: null,
        status_slug: null,
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        agency_internal_number_options: this.$store.getters[
          "agency/getAll"
        ].selectOptions("internal_number", ["internal_number", " - ", "name"]),
        status_slug_options: this.$store.getters["status/getByGroup"]("business").selectOptions(
          "status_slug",
          "name"
        ),
      };
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_internal_number: item.agency ? item.agency.internal_number : null,
            status_slug: item.status ? item.status.status_slug : null,
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("agency/getAllForSelect");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Business/BusinessForm.vue